module.exports = __webpack_public_path__ + "img/Puente_Istobal_FLEX5_3_Alto_Blanco-default-back.b019fed1.jpg";